import DataQuery from 'data/DataQuery';
import { Customer_Get } from 'data/endpoints';
import IRequirementCreateService from 'features/requirements/services/IRequirementCreateService';
import PageCard from 'features/shared/components/card/PageCard';
import IContentDialogService from 'features/shared/components/contentDialog/IContentDialogService';
import FormGroup from 'features/shared/forms/components/FormGroup';
import { useForm } from 'features/shared/forms/hooks/useForm';
import { getRouteParams } from 'features/shared/helpers/routeParams';
import { useInjection } from 'infrastructure/ioc/ioc.react';
import { IocTypes } from 'infrastructure/ioc/ioc.types';
import CustomerState from 'infrastructure/store/customer/CustomerState';
import IAppState from 'infrastructure/store/IAppState';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import BasicInfoSubFormSection from '../basicInfoSubForm/BasicInfoSubFormSection';
import { nameFormValidations } from './nameFormValidation';
import { setNameFormInitValues } from './nameFormInitValues';
import { useQuery } from 'data/hooks/useQuery';
import CustomerDTO from 'features/customer/dtos/CustomerDTO';
import { useTranslation } from 'react-i18next';
import { openRequirementResultDialog } from 'features/requirements/helpers/requirementResultDialogHelper';

const NameFormSection = () => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  // DI
  const createService = useInjection<IRequirementCreateService>(IocTypes.RequirementCreateService);

  // store
  const customerState = (useSelector<IAppState, CustomerState>((store) => store.customer)).customer;

  // fetch data
  let query: DataQuery = {url: Customer_Get, routeParams: getRouteParams("customerId", customerState.customerId!)};
  const { data: customer } = useQuery<CustomerDTO>(query, {}, [customerState]);

  // form hook
  const { values, setFormValue, errors, bindField, bindUncontrolledField, valideteForm, setValidationRule } = useForm({
    initialValidations: nameFormValidations()
  });

  // side effects
  useEffect(() => {
    setNameFormInitValues(customer, setFormValue);
  }, [customer])

  // handlers
  const submitFormHandler = async (e: React.FormEvent) => {
    e.preventDefault();
    if (valideteForm()) {
      let result = await createService.createRequirement("ZMENAJMENAAPRIJMENI", values);
      openRequirementResultDialog(false, { response: result });
    }
  };

  // render
  return (
    <form onSubmit={submitFormHandler}>
      <PageCard title={tLabels("nameFormSection.cardTitle")} bodyClassName="pt-4 px-4">
        <div className="row no-gutters mx-n2">
          <div className="col-sm-6 px-2">
            <FormGroup labelText={tLabels("nameFormSection.name")}>
              <input className="form-control" disabled defaultValue={values["DESC_TMJMENOPUVODNI"] ?? ""} />
            </FormGroup>
          </div>
          <div className="col-sm-6 px-2">
            <FormGroup labelText={tLabels("nameFormSection.newName")} inputId="DESC_TMJMENO" validationError={errors["DESC_TMJMENO"]}>
              <input id="DESC_TMJMENO" className="form-control" placeholder={tLabels("nameFormSection.setNewName")} {...bindField("DESC_TMJMENO")} />
            </FormGroup>
          </div>
          <div className="col-sm-6 px-2">
            <FormGroup labelText={tLabels("nameFormSection.surname")}>
              <input className="form-control" disabled defaultValue={values["DESC_TMPRIJMENIPUVODNI"] ?? ""} />
            </FormGroup>
          </div>
          <div className="col-sm-6 px-2">
            <FormGroup labelText={tLabels("nameFormSection.newSurname")} inputId="DESC_TMPRIJMENI" validationError={errors["DESC_TMPRIJMENI"]}>
              <input id="DESC_TMPRIJMENI" className="form-control" placeholder={tLabels("nameFormSection.setNewSurname")} {...bindField("DESC_TMPRIJMENI")} />
            </FormGroup>
          </div>
        </div>       
      </PageCard>

      <BasicInfoSubFormSection
        bindField={bindField}
        bindUncontrolledField={bindUncontrolledField}
        errors={errors}
        setValidationRule={setValidationRule}
      />

      <button type="submit" className="btn btn-primary px-3 py-2">{tLabels("nameFormSection.sendRequirement")}</button>
    </form>
  )
}

export default NameFormSection;
